/**
 * Submenu wrapper component.
 *
 * Ensures full-width layout for submenu items.
 */

import type { ReactNode } from "react";
import * as stylex from "@stylexjs/stylex";
import * as BloomMenu from "bloom-menu";

import { styles } from "./menu-styles.stylex";

export interface MenuSubMenuProps {
  children: ReactNode;
  id: string;
}

export function MenuSubMenu({ children, id }: MenuSubMenuProps) {
  return (
    <div {...stylex.props(styles.subMenu)}>
      <BloomMenu.SubMenu id={id}>{children}</BloomMenu.SubMenu>
    </div>
  );
}
